import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';

import {Column} from './column';

export class BasicColumn extends Column {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService,
              public isAvg: boolean) {
    super(chart, translate, localization);

    this.setBasicChart();

    this.xAxis = [{
      type: 'category',
      data: Array.from(this.categories)
    }];

    const columns: string[] = this.categories.map((column: string) => this.translate.instant(column));
    this.table = new KeyMetricsTable([], columns, this.categories, []);

    this.getPeriodAggregateData(this.categories).forEach((elementArray: number[], key: string) => {
      const chartData: any = {
        type: 'bar',
        name: key,
        data: elementArray
      };

      if (this.isAvg) {
        chartData.markLine = this.getMarkLine();
        chartData.markPoint = this.getMarkPoint();
      }
      this.series.push(chartData);
      this.pushTableRow(key, elementArray);
    });
  }

  public pushTableRow(key: string, elementArray: number[]): void {
    this.table.addRowHeader(this.translate.instant(key));
    this.table.addData(elementArray
      .map((dataElement: number) => this.localization.localizeNumber(dataElement, 'DECIMAL_2_DIGIT'))
    );
  }
}
